import { USER_TRACKING_EVENTS } from "@website/tracking/tracking.types";
import { addEventToTracking } from "@website/tracking/user";
import debounce from "lodash-es/debounce";
import toNumber from "lodash-es/toNumber";
import toString from "lodash-es/toString";
import { useRouter } from "next/router";
import { useCallback, useEffect } from "react";
import { RoomDataType, RoomPropertyResponseType } from "./index.types";

export const useRoomPageTracking = (
  roomData: RoomDataType,
  roomProperty: RoomPropertyResponseType
) => {
  const router = useRouter();

  useEffect(() => {
    if (!roomData) return;

    const debouncedTrackEvent = debounce(() => {
      addEventToTracking(USER_TRACKING_EVENTS.PAGE_VISIT_PROPERTY, {
        product: "villa",
        date_from: new Date(router.query["date_from"] as string),
        date_to: new Date(router.query["date_to"] as string),
        passenger_no: toNumber(router.query["room_capacity"]) || 0,
        region: roomData.property?.city?.title,
        region_id: toString(roomData.property?.city?.id),
        property_name: roomData.property?.title,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-expect-error
        property_id: roomData?.property?.id
      });
    }, 500);

    debouncedTrackEvent();

    return () => {
      debouncedTrackEvent.cancel();
    };
  }, [roomData, router]);

  const handleTrackReserveButtonClicked = useCallback(() => {
    addEventToTracking(USER_TRACKING_EVENTS.RESERVE_BUTTON_CLICKED, {
      product: "villa",
      date_from: new Date(router.query["date_from"] as string),
      date_to: new Date(router.query["date_to"] as string),
      city: roomData.property?.city?.title,
      city_id: roomData.property?.city?.id,
      hotel: roomData.property?.title,
      hotel_id: roomData.property?.id,
      rooms: [
        {
          title: roomData?.title,
          id: roomProperty?.room_id,
          local_price: roomProperty?.total_price,
          local_price_off: roomProperty?.total_local_price_off,
          type_id: 0,
          available_rooms: 0,
          base_price: 0,
          original_sell_price: 0,
          bed_price: 0,
          child_price: 0,
          has_foreign_guest: false,
          extra_bed: 0,
          breakfast_included: false,
          adult: 0,
          child: 0,
          child_age: 0,
          infant_age: 0,
          adult_reserved: 0,
          child_reserved: 0
        }
      ],
      is_available: roomProperty.availability > 0
    });
  }, [roomData, roomProperty, router.query]);

  return { handleTrackReserveButtonClicked };
};

export const handleFacilicyModalScrollChanged = (data) => {
  addEventToTracking(
    USER_TRACKING_EVENTS.VILLA_AMENITIES_MODAL_SCROLL_CHANGED,
    {
      product: "villa",
      ...data
    }
  );
};
